import React, {useEffect, useState} from 'react';
import {GridCellExpand} from "../../components/GridCellExpand/GridCellExpand.jsx";
export const RenderDescription = (params) => {

  return (
    <GridCellExpand
        value={params.value ? params.value.toString() : ''}
        width={params.colDef.computedWidth}
    />
  )



}

export const topColumns = [
    
  {
    field: "index",
    headerName: " ",
    width: 50,
    type: "number",
    sortable: false,
    align: "center",
    headerAlign: "center",
  },  
    {
      field: "size",
      headerName: "Кол-во нарушений",
      width: 100,
      type: "number",
      align: "center",
      headerAlign: "center"      
    },
    { field: "reference", headerName: "Ссылка", minWidth: 250, renderCell: RenderDescription },
    { field: "shortText", headerName: "Описание", minWidth: 450, renderCell: RenderDescription },
   
  ]
  